import { TooltipProvider } from "@/components/ui/tooltip";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ScrollToTop } from "@/components/ScrollToTop";
import { lazy, Suspense } from "react";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";

// Lazy load secondary pages for better initial bundle size
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const Blog = lazy(() => import("./pages/Blog"));
const BlogPost = lazy(() => import("./pages/BlogPost"));
const Parrainage = lazy(() => import("./pages/Parrainage"));
const DeclarationFrontalier = lazy(() => import("./pages/DeclarationFrontalier"));
const DeclarationPermisB = lazy(() => import("./pages/DeclarationPermisB"));
const DeclarationResident = lazy(() => import("./pages/DeclarationResident"));
const TroisiemePilier = lazy(() => import("./pages/TroisiemePilier"));
const AssuranceMaladieImpots = lazy(() => import("./pages/AssuranceMaladieImpots"));
const HypothequeImpots = lazy(() => import("./pages/HypothequeImpots"));

// Lazy load toast components, cookie consent and analytics - not needed on initial render
const Toaster = lazy(() => import("@/components/ui/toaster").then(m => ({ default: m.Toaster })));
const Sonner = lazy(() => import("@/components/ui/sonner").then(m => ({ default: m.Toaster })));
const CookieConsent = lazy(() => import("@/components/CookieConsent"));
const GoogleAnalytics = lazy(() => import("@/components/GoogleAnalytics"));

const App = () => (
  <TooltipProvider>
    <Suspense fallback={null}>
      <Toaster />
      <Sonner />
    </Suspense>
    <BrowserRouter>
      <ScrollToTop />
      <Suspense fallback={null}>
        <GoogleAnalytics />
        <CookieConsent />
      </Suspense>
      <Suspense fallback={<div className="min-h-screen bg-background" />}>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/politique-de-confidentialite" element={<PrivacyPolicy />} />
          <Route path="/mentions-legales" element={<Navigate to="/politique-de-confidentialite#mentions-legales" replace />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/parrainage" element={<Parrainage />} />
          <Route path="/declaration-impots-frontalier" element={<DeclarationFrontalier />} />
          <Route path="/declaration-impots-permis-b" element={<DeclarationPermisB />} />
          <Route path="/declaration-impots-resident" element={<DeclarationResident />} />
          <Route path="/3eme-pilier" element={<TroisiemePilier />} />
          <Route path="/assurance-maladie-impots" element={<AssuranceMaladieImpots />} />
          <Route path="/hypotheque-impots" element={<HypothequeImpots />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  </TooltipProvider>
);

export default App;
